import { render, staticRenderFns } from "./AddInsurer.vue?vue&type=template&id=0c779aac&scoped=true&"
import script from "./AddInsurer.vue?vue&type=script&lang=js&"
export * from "./AddInsurer.vue?vue&type=script&lang=js&"
import style0 from "./AddInsurer.vue?vue&type=style&index=0&id=0c779aac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c779aac",
  null
  
)

export default component.exports